import React from 'react';
import PropTypes from 'prop-types';
import { FDHeadlineText, FDStack, FDTitleText } from '@facet-wealth/design';
import {
  ToolActionButton,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/AutomationSuggestionsPicker/AutomationSuggestions/Content/ActionButton';

const ToolPicker = ({ toolResource }) => {
  return (
    <FDStack paddingY={3} direction={'column'} spacing={2}>
      <FDHeadlineText size={'sm'} value={toolResource.attr('name')} />
      <FDStack direction={'column'} spacing={1}>
        <FDStack direction={'row'} key={toolResource.id()} spacing={1}>
          <FDTitleText value={toolResource.attr('description')} />
          <FDStack flexGrow={1} />
          <ToolActionButton toolResource={toolResource} />
        </FDStack>
      </FDStack>
    </FDStack>
  );
};

ToolPicker.propTypes = {
  toolResource: PropTypes.object.isRequired,
};

export default ToolPicker;
